import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import headerImg from "../assets/img/cats.svg";

export const Banner = () => {

    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const toRotate = ["Computer Science & Engineering student"];
    const [text, setText] = useState('');
    const [delta, setDelta] = useState(300, Math.random() *100);
    const period = 2000;

    useEffect(() => {
        let ticker = setInterval(() => {
            tick();
        }, delta);

        return () => { clearInterval(ticker)};
    }, [text])

    const tick = () => {
        let i = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting ? fullText.substring(0, text.length -1) : fullText.substring(0, text.length + 1);

        setText(updatedText)

        if (isDeleting) {
            setDelta(prevDelta => prevDelta/2);
        }

        if (!isDeleting && updatedText === fullText) {
            setIsDeleting(false); //change here to true for deleting
            setDelta(period);
        } else if (isDeleting && updatedText === '') {
            setIsDeleting(false);
            setLoopNum(loopNum + 1);
            setDelta(500);   
        }
    }


    return (
        <section className="banner" id="home">
            <Container>
                <Row className="align-items-center">
                    <Col xs={12} md={6} xl={7}>
                        {/* <span className="tagline"> Welcome to my Website</span> */}
                        <h1>{`Hi I'm Liora!`}</h1>
                        <h2><span className="wrap">{text}</span></h2>
                        <p>Welcome to my website! I'm a Computer Science & Engineering student at TU Delft, where I get to dive into the world of technology and problem-solving. I’m all about finding creative ways to tackle real-world challenges and make life a little easier through code. Throughout my education, I’ve learned about software development, data analysis, and even got my hands dirty with data migration and keeping everything running smoothly.</p>
                            <p>I speak English, Dutch, and French fluently, which has made collaborating and meeting people from all over super exciting. When I'm not coding or studying, you'll probably find me trying out fun projects, horse riding, or working out. I’m always up for learning something new, building cool stuff, and meeting people who share a love for tech and innovation. Let's make a difference, one line of code at a time!</p>
                        {/* <button onClick={() => console.log('connect')}>Let's connect <ArrowRightCircle size={25} /></button> */}
                    </Col>
                    <Col xs={12} md={6} xl={5}>
                        <img src={headerImg} alt="Header Img" className="custom-header-img" />
                    </Col>
                </Row>
            </Container>
        </section>

    )
}